import React, { useState, useEffect } from "react";
import axios from "axios";
import { useAdminAuth } from "../../auth/AdminAuthProvider";
import { BASE_URL } from "../../../env";
import DashboardHeader from "../../../components/layout/DashboardHeader";
import Sidebar from "../../../components/layout/Sidebar";
import { Table, InputGroup, FormControl, Button } from "react-bootstrap";
import MemberDetailsModal from "../components/MemberDetailsModal";
import { IoSearch } from "react-icons/io5";
import { FaAngleRight, FaAngleLeft, FaUsers } from "react-icons/fa";
import "../../dashboard/screens/Pagination.css";

const RejectedMemberDetails = () => {
  const { adminUser } = useAdminAuth();
  const [openSidebarToggle, setOpenSidebarToggle] = useState(window.innerWidth > 1000);
  const [searchTerm, setSearchTerm] = useState("");
  const [memberData, setMemberData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [showModal, setShowModal] = useState(false);
  const [selectedMemberId, setSelectedMemberId] = useState(null);

  const OpenSidebar = () => {
    setOpenSidebarToggle(!openSidebarToggle);
  };

  useEffect(() => {
    const fetchMemberDetails = async () => {
      try {
        let response;
        if (adminUser.userType === "superadmin") {
          response = await axios.get(
            `${BASE_URL}/api/getmemberdetails/ByAccountManagerId/?accountManagerId=${adminUser.user.id}&accountManagerStatus=rejected`
          );
        } else if (adminUser.userType === "Credit Manager") {
          response = await axios.get(
            `${BASE_URL}/api/getmemberdetails/ByCreditManagerId?creditManagerId=${adminUser.user.id}&creditManagerStatus=rejected`
          );
        } else if (adminUser.userType === "Branch Manager") {
          response = await axios.get(`${BASE_URL}/branch-manager/members`);
        } else if (adminUser.userType === "Accounts Manager") {
          response = await axios.get(
            `${BASE_URL}/api/getmemberdetails/ByAccountManagerId/?accountManagerId=${adminUser.user.id}&accountManagerStatus=rejected`
          );
        }
        setMemberData(response.data.list);
      } catch (error) {
        console.error("Error fetching member details:", error);
      }
    };

    fetchMemberDetails();
  }, [adminUser.user.id, adminUser.userType]);

  // Filter the entire dataset
  const filteredMembers = memberData.filter(
    (member) =>
      member.memberName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      member.branchName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredMembers.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(filteredMembers.length / itemsPerPage);

  const handlePageChange = (pageNumber) => {
    if (pageNumber > 0 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  const handleShowModal = (memberId) => {
    setSelectedMemberId(memberId);
    setShowModal(true);
  };

  return (
    <section className="master-layout">
      <div className="master-sidebar-wrapper">
        <Sidebar
          openSidebarToggle={openSidebarToggle}
          OpenSidebar={OpenSidebar}
        />
      </div>

      <div className="master-content-wrapper">
        <div className="master-header-wrapper">
          <DashboardHeader OpenSidebar={OpenSidebar} />
        </div>

        <div className="master-card-container">
          <div className="master-search-section">
            <h1 className="TableHeaderText w-100 text-start text-danger">Rejected Member Details</h1>
            <div className="search-input-wrapper" style={{ minWidth: "300px" }}>
              <span className="search-icon">
                <IoSearch color="#666" />
              </span>
              <input
                type="text"
                placeholder="Search by Member Name or Branch Name..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="search-input"
              />
            </div>
          </div>

          <div className="master-list-section">
            <div className="master-table-wrapper table-responsive p-0" style={{ padding: "0 15px" }}>
              <Table hover className="align-middle mb-0 table-list">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Photo</th>
                    <th>Member Name</th>
                    <th>Phone Number</th>
                    <th>Applied Date</th>
                    <th>Branch Name</th>
                    <th>Status</th>
                    <th className="text-center">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {currentItems.length > 0 ? (
                    currentItems.map((member, index) => {
                      const combinedStatus = `CO: ${member.creditOfficerStatus} | BM: ${member.branchManagerStatus} | AM: ${member.accountManagerStatus}`;

                      return (
                        <tr key={member.member_id}>
                          <td className="fw-bold text-muted">{indexOfFirstItem + index + 1}</td>
                          <td>
                            <img
                              src={`${BASE_URL}/images/${member.memberPhoto}`}
                              width={40}
                              height={40}
                              className="rounded-circle object-fit-cover shadow-sm border"
                              alt="Member"
                            />
                          </td>
                          <td>
                            <div className="fw-bold">{member.memberName}</div>
                          </td>
                          <td>{member.memberPhoneNumber}</td>
                          <td>{member.appliedDate}</td>
                          <td>{member.branchName}</td>
                          <td>
                            <small className="text-danger fw-medium d-block">
                              {combinedStatus}
                            </small>
                          </td>
                          <td className="text-center">
                            <Button
                              variant="primary"
                              size="sm"
                              onClick={() => handleShowModal(member.member_id)}
                              className="px-3"
                            >
                              View
                            </Button>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="8" className="text-center py-5 text-muted">
                        No member data available.
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>

            {totalPages > 1 && (
              <div className="master-pagination-wrapper">
                <nav className="pagination-container w-100">
                  <div className="total-data-badge">
                    <FaUsers /> Total Records: <span>{filteredMembers.length}</span>
                  </div>

                  <ul className="premium-pagination">
                    <li>
                      <button
                        className="pagination-btn nav-btn"
                        disabled={currentPage === 1}
                        onClick={() => handlePageChange(currentPage - 1)}
                      >
                        <FaAngleLeft style={{ marginRight: '6px' }} />
                        <span>Previous</span>
                      </button>
                    </li>

                    <li>
                      <div className="pagination-btn page-active">
                        Page <span>{currentPage}</span> / {totalPages}
                      </div>
                    </li>

                    <li>
                      <button
                        className="pagination-btn nav-btn"
                        disabled={currentPage === totalPages}
                        onClick={() => handlePageChange(currentPage + 1)}
                      >
                        <span>Next</span>
                        <FaAngleRight style={{ marginLeft: '6px' }} />
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
            )}
          </div>
        </div>
      </div>

      {showModal && (
        <MemberDetailsModal
          show={showModal}
          handleClose={() => setShowModal(false)}
          memberId={selectedMemberId}
        />
      )}
    </section>
  );
};

export default RejectedMemberDetails;
